import { Box, Button, CircularProgress, Stack, Typography } from "@mui/joy";
import CustomModal from "components/common/CustomModal";
import React, { useCallback, useEffect, useRef, useState } from "react";
import pcAndMobileImg from "static/image/payment/pc_and_mobile.png";
import reviewAvatar1Img from "static/image/payment/review_avatar_1.svg";
import reviewAvatar2Img from "static/image/payment/review_avatar_2.svg";
import reviewAvatar3Img from "static/image/payment/review_avatar_3.svg";
import numWithCircle1Img from "static/image/payment/NumWithCircle_1.svg";
import numWithCircle2Img from "static/image/payment/NumWithCircle_2.svg";
import numWithCircle3Img from "static/image/payment/NumWithCircle_3.svg";
import numWithCircle4Img from "static/image/payment/NumWithCircle_4.svg";
import numWithCircle5Img from "static/image/payment/NumWithCircle_5.svg";
import dividerImg from "static/image/payment/divider.svg";
import coachingTimeImg from "static/image/payment/coaching_time.svg";
import coachingRoutine1Img from "static/image/payment/coaching_routine_1.svg";
import coachingRoutine2Img from "static/image/payment/coaching_routine_2.svg";
import coachingRoutine3Img from "static/image/payment/coaching_routine_3.svg";
import coachingCount1Img from "static/image/payment/coaching_count_1.svg";
import coachingCount2Img from "static/image/payment/coaching_count_2.svg";
import coachingCount3Img from "static/image/payment/coaching_count_3.svg";
import checkIconImg from "static/image/payment/Check.svg";
import paybackMarkImg from "static/image/onboarding/payback_guarantee.svg";
import calendarImg from "static/image/payment/calendar.svg";
import manyImg from "static/image/payment/many.svg";
import cheaperImg from "static/image/payment/cheaper.svg";
import chart100Img from "static/image/payment/chart_100.svg";
import sponsorImg from "static/image/payment/sponsor_payment.png";
import fivestarsImg from "static/image/onboarding/fivestars.svg";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";
import useGetUrls from "hooks/useGetUrls";
import { sendMessage } from "utils/webview";
import useIsInappWebview from "hooks/useIsInappWebview";
import { theme } from "styles/theme";
import FloatingArea from "components/common/FloatingArea";
import { extractHexColor } from "../../../styles/hexOpacity";
import { useRecoilState } from "recoil";
import { paymentOrderAtom } from "../../../recoil/paymentOrderAtom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  PAYMENT_COACH_SEAT_COUNT_ENDPOINT,
  PAYMENT_DOMAIN,
  PAYMENT_ORDER_DETAIL_ENDPOINT,
  paymentApi,
} from "api/paymentApi";
import { userAtom } from "../../../recoil/userAtom";
import CustomTypography from "../../common/CustomTypography";
import { onboardingApi } from "../../../api/onboardingApi";
import CustomTypographyHighlight from "../../common/CustomTypographyHighlight";
import ContentTemplateV2 from "../content/ContentTemplateV2";
import UserInfo from "../../user/UserInfo";
import CxButton from "../../sidebar/CXButton";
import LinkV2 from "../../common/LinkV2";
import ReviewItem from "./elements/ReviewItem";
import { compareVersions } from "../../../logic/logics_common";
import { USER_DETAIL_ENDPOINT, USER_DOMAIN, userApi } from "api/userApi";
import { axiosInstance } from "../../../api";
import rocketImg from "../../../static/image/payment/rocket.svg";
import focusCoachingImg from "../../../static/image/onboarding/focus_coaching.svg";
import taskUpdateMechanism from "../../../static/image/payment/task_update_mechanism.png";
import muscleImg from "../../../static/image/payment/muscle.svg";
import tool2Img from "../../../static/image/payment/tool_2.svg";
import tool3Img from "../../../static/image/payment/tool_3.svg";
import tool4Img from "../../../static/image/payment/tool_4.svg";
import tool5Img from "../../../static/image/payment/tool_5.svg";
import tool6Img from "../../../static/image/payment/tool_6.svg";
import tool7Img from "../../../static/image/payment/tool_7.svg";
import tool8Img from "../../../static/image/payment/tool_8.svg";
import useMixpanelWeb from "../../../hooks/useMixpanelWeb";
import CheckIcon from "../../icons/CheckIcon";
import InfoIcon from "../../icons/InfoIcon";
import CompareWithCounseling395 from "./elements/CompareWithCounseling395";
import PaymentButtonWithPlanSelection from "./elements/PaymentButtonWithPlanSelection";
import FAQTypeC from "./elements/FAQTypeC";
import mixpanel from "mixpanel-browser";
import { PlanItem, PlanKey } from "./planTypes";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const numberWithCircle = [
  numWithCircle1Img,
  numWithCircle2Img,
  numWithCircle3Img,
  numWithCircle4Img,
  numWithCircle5Img,
];

const majorTrainingPlan = [
  "내적 변화를 알아차리기",
  "주의력을 통제하며 경험을 분리하기",
  "생각을 심리적 사건으로 바라보기",
  "회피하지 않고 기꺼이 받아들이기",
  "삶의 가치를 향해 전념하기",
];

const programFeatures = [
  {
    main: "인지심리학 핵심 이론",
  },
  {
    main: "전담 코치의 1:1 지원",
  },
  {
    main: "감정, 신체 안정화 도구",
  },
  {
    main: "기술 연습을 위한 명상",
  },
  {
    main: "실생활 적용을 위한 기록지",
  },
];

interface ComparisonItem {
  type: "quantity" | "cost";
  title: string;
  text: string;
  icon: string;
}

const comparisonItems: ComparisonItem[] = [
  {
    type: "quantity",
    title: "심리상담보다\n6배 더 많이",
    text: "디스턴싱에서는 일주일에 약 300분에 달하는 활동이 제공됩니다. 반면 일반적인 심리상담은 일주일에 50분만 진행합니다.",
    icon: manyImg,
  },
  {
    type: "cost",
    title: "심리상담보다\n4배 더 싸게",
    text: "최상위 마스터 플랜의 이용 요금은 일주일에 3만 원 대에 불과합니다. 반면 일반적인 1급 심리상담은 일주일에 12만 원 이상이 듭니다.",
    icon: cheaperImg,
  },
];

const toolFeatures = [
  { icon: tool2Img, text: "부정 경험 분석지" },
  { icon: tool3Img, text: "가치 발견 기록지" },
  { icon: tool4Img, text: "근육 이완 도구" },
  { icon: tool5Img, text: "호흡 안정화 도구" },
  { icon: tool6Img, text: "감정 조절 도구" },
  { icon: tool7Img, text: "수용 전념 명상" },
  { icon: tool8Img, text: "주의력 훈련 명상" },
];

const plans: PlanItem[] = [
  {
    key: "starter",
    name: "스타터",
    price: 295000,
    features: [
      { text: "기본 코칭 (주 최대 2회)", included: true, info: true },
      { text: "14일 내 전액 환불 보장", included: true },
    ],
    guarantee: "14일 전액 환불 보장",
  },
  {
    key: "challenger",
    name: "챌린저",
    price: 395000,
    tag: "가장 인기 있는",
    features: [
      { text: "집중 코칭 (일 최대 1회)", included: true, info: true },
      { text: "기본 정기 검사", included: true, info: true },
      { text: "14일 내 전액 환불 보장", included: true },
    ],
    guarantee: "14일 전액 환불 보장",
  },
  {
    key: "master",
    name: "마스터",
    price: 465000,
    tag: "가장 밀도 있는",
    features: [
      {
        text: "프리미엄 코칭 (일 최대 2회, 최우선 관리)",
        included: true,
        info: true,
      },
      { text: "기본 정기 검사", included: true, info: true },
      { text: "14일 내 전액 환불 보장", included: true },
    ],
    guarantee: "14일 전액 환불 보장",
  },
];

const formatCurrency = (n: number) => n.toLocaleString("ko-KR");

// KST(UTC+9)로 사람이 읽기 쉬운 형식: YYYY-MM-DD HH:mm:ss KST
const formatKst = (ms: number) => {
  const t = new Date(ms + 9 * 60 * 60 * 1000); // UTC+9 보정
  const yyyy = t.getUTCFullYear();
  const MM = String(t.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(t.getUTCDate()).padStart(2, "0");
  const HH = String(t.getUTCHours()).padStart(2, "0");
  const mm = String(t.getUTCMinutes()).padStart(2, "0");
  const ss = String(t.getUTCSeconds()).padStart(2, "0");
  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss} KST`;
};

export default function PaymentContentDefault({
  isFromOnboarding = false,
}: {
  isFromOnboarding?: boolean;
}) {
  const floatingAreaRef = useRef<HTMLDivElement>(null);
  const planSectionRef = useRef<HTMLDivElement>(null); // 플랜 섹션 ref
  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  const paddingX = 4.5;

  const [user, setUser] = useRecoilState(userAtom);
  const refundLabel =
    user?.refundPolicyType === "a"
      ? "효과 보장 페이백"
      : "14일 내 전액 환불 보장";
  const guaranteeLabel =
    user?.refundPolicyType === "a"
      ? "불만족시 전액 페이백"
      : "14일 전액 환불 보장";

  const [paymentOrderState, setPaymentOrderState] =
    useRecoilState(paymentOrderAtom);

  const isFirstOrder = paymentOrderState?.isFirst;
  const fullWidth = isFirstOrder ? true : !!isInappWebview;

  const [countCoachSeatRemain, setCountCoachSeatRemain] = useState<
    number | undefined
  >(undefined);

  // type D 페이지 여부
  const isTypeD = user?.paymentPageType === "d";

  useQuery(
    [PAYMENT_DOMAIN, PAYMENT_ORDER_DETAIL_ENDPOINT, user?.userId],
    () => paymentApi.getOrderDetail(),
    {
      enabled:
        !!axiosInstance.defaults.headers["X-Auth-Token"] && !!user?.accessToken,
      onSuccess: (data) => {
        if (data && data.result) {
          setPaymentOrderState(data.result);
        }
      },
    }
  );

  useQuery(
    [PAYMENT_DOMAIN, PAYMENT_COACH_SEAT_COUNT_ENDPOINT],
    () => paymentApi.countRemainCoachSeat(),
    {
      enabled: true,
      refetchInterval: 5000,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: true,
      onSuccess: (data) => {
        if (data && data.result) {
          // Always update, including 0, so UI reflects real-time count
          setCountCoachSeatRemain(data.result.countRemainCoachSeat ?? 0);
        } else {
          setCountCoachSeatRemain(undefined);
        }
      },
    }
  );

  // Fetch latest user detail to ensure subscription state is up-to-date before firing Mixpanel
  const { isFetched: isUserFetched } = useQuery(
    [USER_DOMAIN, USER_DETAIL_ENDPOINT],
    useCallback(() => userApi.getDetail(), []),
    {
      enabled:
        !!axiosInstance.defaults.headers["X-Auth-Token"] && !!user?.accessToken,
      onSuccess: (data) => {
        if (data && data.result) {
          setUser((user) => ({
            ...user,
            ...data.result,
          }));
        }
      },
    }
  );

  const pageKey = "payment_1";
  const SCROLL_CONTAINER_ID = "payment-scroll-container";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  const setMixPanel = useMixpanelWeb({
    eventName: "결제 페이지 진입",
  });

  const sentEventRef = useRef(false);
  // 결제 성공 후 재진입 시 page view 관련 이벤트(meta, firebase, appsflyer, mixpanel) 전송 차단 플래그
  const suppressPageViewRef = useRef<boolean>(
    (() => {
      try {
        return localStorage.getItem("suppress_payment_page_view") === "1";
      } catch (e) {
        return false;
      }
    })()
  );

  useEffect(() => {
    // 플래그는 1회성으로 사용 후 제거
    if (suppressPageViewRef.current) {
      try {
        localStorage.removeItem("suppress_payment_page_view");
      } catch (e) {}
    }
  }, []);

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
    if (!isFromOnboarding && !suppressPageViewRef.current) {
      setMixPanel(); // 재결제의 경우 mixpanel 만 보내줌
    }
  });

  useEffect(() => {
    if (
      !sentEventRef.current &&
      !suppressPageViewRef.current &&
      isFromOnboarding &&
      isUserFetched &&
      user?.subscription?.isSubscribing !== true
    ) {
      // meta event
      if (
        user?.isInsider !== true &&
        isInappWebview &&
        compareVersions(appVersion, "1.1.51") >= 0
      ) {
        if (user?.segmentType) {
          sendMessage(
            JSON.stringify({
              event: "send_meta_capi_event",
              params: {
                eventId: uuidv4(),
                eventName: `page_view_payment_type_${user?.segmentType}`,
                eventParams: {
                  content_ids: [`distancing_program_type_${user?.segmentType}`],
                  content_type: "product",
                  content_name: `디스턴싱 프로그램 Type ${user?.segmentType}`,
                  content_category: "Digital Program",
                  value: user?.segmentType === "a" ? 24000 : 0,
                  currency: "KRW",
                },
              },
            })
          );
        }
        if (user?.symptomType) {
          sendMessage(
            JSON.stringify({
              event: "send_meta_capi_event",
              params: {
                eventId: uuidv4(),
                eventName: `page_view_payment_symptom_${user?.symptomType}`,
                eventParams: {
                  content_ids: [
                    `distancing_program_symptom_${user?.symptomType}`,
                  ],
                  content_type: "product",
                  content_name: `디스턴싱 프로그램 Symptom ${user?.symptomType}`,
                  content_category: "Digital Program",
                  value: 0,
                  currency: "KRW",
                },
              },
            })
          );
        }
        sendMessage(
          JSON.stringify({
            event: "send_meta_capi_event",
            params: {
              eventId: uuidv4(),
              eventName: "page_view_payment",
              eventParams: {
                content_ids: ["distancing_program_main"],
                content_type: "product",
                content_name: "디스턴싱 프로그램",
                content_category: "Digital Program",
                value: 16000,
                currency: "KRW",
              },
            },
          })
        );
      } else if (
        user?.isInsider !== true &&
        isInappWebview &&
        compareVersions(appVersion, "1.1.17") >= 0
      ) {
        if (user?.segmentType) {
          sendMessage(
            JSON.stringify({
              event: "send_fb_event",
              params: {
                eventName: `page_view_payment_type_${user?.segmentType}`,
              },
            })
          );
        }
        if (user?.symptomType) {
          sendMessage(
            JSON.stringify({
              event: "send_fb_event",
              params: {
                eventName: `page_view_payment_symptom_${user?.symptomType}`,
              },
            })
          );
        }
        sendMessage(
          JSON.stringify({
            event: "send_fb_event",
            params: {
              eventName: "page_view_payment",
            },
          })
        );
      }

      // firebase, appsflyer event
      if (
        user?.isInsider !== true &&
        isInappWebview &&
        compareVersions(appVersion, "1.1.47") >= 0
      ) {
        sendMessage(
          JSON.stringify({
            event: "send_firebase_analytics_event",
            params: {
              eventName: "screen_view",
              eventParams: {
                screen_name: "PaymentScreen",
                screen_class: "PaymentScreenComponent",
              },
            },
          })
        );

        sendMessage(
          JSON.stringify({
            event: "send_appsflyer_event",
            params: {
              eventName: "af_content_view",
              eventParams: {
                af_content_id: "distancing_program_initiate",
              },
            },
          })
        );

        if (user?.segmentType) {
          sendMessage(
            JSON.stringify({
              event: "send_firebase_analytics_event",
              params: {
                eventName: "screen_view",
                eventParams: {
                  screen_name: `PaymentScreen_type_${user?.segmentType}`,
                  screen_class: "PaymentScreenComponent",
                },
              },
            })
          );
        }
      }

      if (!suppressPageViewRef.current) {
        setMixPanel();
      }

      sentEventRef.current = true;
    }
  }, [isFromOnboarding, isUserFetched, user?.subscription?.isSubscribing]);

  const { companyInfoUrl, privacyPolicyUrl, servicePolicyUrl } = useGetUrls();
  const hasSentSafeAreaColorRef = useRef(false);

  useEffect(() => {
    if (hasSentSafeAreaColorRef.current) return;
    if (!(isInappWebview && paymentOrderState)) return;

    const topBackground = extractHexColor(theme.vars.palette.Background.Level3);
    const bottomBackground = extractHexColor(
      theme.vars.palette.Background.Level1
    );

    if (topBackground && bottomBackground) {
      sendMessage(
        JSON.stringify({
          event: "set_safearea_color",
          params: {
            topColor: `${topBackground}`,
            bottomColor: `${bottomBackground}`,
          },
        })
      );
      hasSentSafeAreaColorRef.current = true;
    }
  }, [isInappWebview, paymentOrderState]);

  const { homeIndicatorHeight } = useGetDeviceInfo();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - homeIndicatorHeight
  );
  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  useEffect(() => {
    setTimeout(() => {
      setFloatingAreaHeight(floatingAreaRef.current?.offsetHeight || 0);
    }, 100);
  }, [floatingAreaRef.current]);

  /* -----------------------------
     신규: 선택된 플랜 상태/헬퍼
  ------------------------------ */
  const SESSION_SELECTED_PLAN_KEY =
    "payment.selectedPlan.100dayABC.withCommitment";
  const [selectedPlan, setSelectedPlan] = useState<PlanKey>(() => {
    try {
      if (typeof window !== "undefined") {
        const saved = sessionStorage.getItem(SESSION_SELECTED_PLAN_KEY);
        if (
          saved &&
          (saved === "starter" || saved === "challenger" || saved === "master")
        ) {
          return saved as PlanKey;
        }
      }
    } catch {}
    return "challenger";
  });
  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        sessionStorage.setItem(SESSION_SELECTED_PLAN_KEY, selectedPlan);
      }
    } catch {}
  }, [selectedPlan]);
  const selectedPlanObj = plans.find((p) => p.key === selectedPlan)!;

  const planTitleRef = useRef<HTMLDivElement>(null); // title anchor

  type InfoModalData = { title: string; subtitle: string; action: string };

  const INFO_CONTENTS: Record<string, InfoModalData> = {
    "기본 코칭 (주 최대 2회)": {
      title: "기본 코칭",
      subtitle:
        "일주일에 최대 2회, 코치의 피드백과 함께 맞춤 활동지가 제공됩니다. 프로그램 진도도 매주 최대 2회까지 나가게 됩니다.",
      action: "확인",
    },
    "집중 코칭 (일 최대 1회)": {
      title: "집중 코칭",
      subtitle:
        "하루 최대 1회, 코치의 피드백과 함께 맞춤 활동지가 제공됩니다. 프로그램 진도도 매일 최대 1회까지 나가게 됩니다.",
      action: "확인",
    },
    "프리미엄 코칭 (일 최대 2회, 최우선 관리)": {
      title: "프리미엄 코칭",
      subtitle:
        "하루 최대 2회, 코치의 피드백과 함께 맞춤 활동지가 가장 먼저 제공됩니다. 프로그램 진도도 매일 최대 2회까지 나가게 됩니다.",
      action: "확인",
    },
    "심층 정기 검사 & 리포트": {
      title: "심층 정기 검사 & 리포트",
      subtitle:
        "정신건강 기본 항목 외 추가 지표까지 2주마다 정기적으로 측정합니다. 검사 후에는 프로그램과 연계한 분석 리포트가 제공됩니다.",
      action: "확인",
    },
    "기본 정기 검사": {
      title: "기본 정기 검사",
      subtitle: "정신건강 기본 항목을 2주마다 정기적으로 측정합니다.",
      action: "확인",
    },
  };

  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [infoModal, setInfoModal] = useState<InfoModalData>({
    title: "",
    subtitle: "",
    action: "확인",
  });

  const handleOpenInfo = (featureText: string) => {
    const next = INFO_CONTENTS[featureText] || {
      title: featureText,
      subtitle: "자세한 내용은 고객센터로 문의해주세요.",
      action: "확인",
    };
    setInfoModal(next);
    setInfoModalOpen(true);
  };

  const handleOpenInfoCoachSeat = (planName: string) => {
    setInfoModal({
      title: "정원 제한",
      subtitle: `최상의 프로그램 진행 경험을 위해, 코치별 담당 인원을 제한하고 있습니다. 현재 ${planName} 플랜의 정원 마감이 임박하였습니다.`,
      action: "확인",
    });
    setInfoModalOpen(true);
  };

  const handleScrollToPlans = () => {
    const targetEl = planTitleRef.current || planSectionRef.current;
    if (!targetEl) return;
    const container = document.getElementById(SCROLL_CONTAINER_ID);
    if (container) {
      const containerRect = container.getBoundingClientRect();
      const targetRect = targetEl.getBoundingClientRect();
      const top = targetRect.top - containerRect.top + container.scrollTop;
      (container as HTMLElement).scrollTo({ top, behavior: "smooth" });
    } else {
      const top = targetEl.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  useEffect(() => {
    mixpanel.start_session_recording();

    return () => {
      mixpanel.stop_session_recording();
    };
  }, []);

  const [remainingSeconds, setRemainingSeconds] = useState<number | null>(null);
  const [showCountdownSection, setShowCountdownSection] = useState<boolean>(false);

  useEffect(() => {
    if (!isFirstOrder) {
      setRemainingSeconds(null);
      setShowCountdownSection(false);
      return;
    }
    const ts = paymentOrderState?.firstPaymentPageViewAt;
    if (!ts) {
      setRemainingSeconds(null);
      setShowCountdownSection(false);
      return;
    }
    const KST = "Asia/Seoul";
    const startKST = dayjs.tz(ts, KST);
    if (!startKST.isValid()) {
      setRemainingSeconds(null);
      setShowCountdownSection(false);
      return;
    }
    const expiry = startKST.add(15, "minute");
    setShowCountdownSection(true);

    const compute = () => {
      const currentKST = dayjs().tz(KST);
      const secs = Math.max(0, expiry.diff(currentKST, "second"));
      setRemainingSeconds(secs);
    };

    compute();
    const id = setInterval(() => {
      const currentKST = dayjs().tz(KST);
      const secs = Math.max(0, expiry.diff(currentKST, "second"));
      setRemainingSeconds(secs);
      if (secs <= 0) {
        clearInterval(id);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [isFirstOrder, paymentOrderState?.firstPaymentPageViewAt]);

  const formatHHMMSS = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const p = (n: number) => n.toString().padStart(2, "0");
    return `${p(hours)}:${p(minutes)}:${p(seconds)}`;
  };

  const showCountdown =
    !!isFirstOrder &&
    user?.paymentPageType === "d" &&
    showCountdownSection &&
    remainingSeconds !== null;

  // Show a loading indicator in the center when paymentOrderState is not ready
  if (!paymentOrderState) {
    return (
      <ContentTemplateV2
        noPadding
        isWide
        setContainerHeight={setContainerHeight}
        containerId={SCROLL_CONTAINER_ID}
      >
        <Stack
          sx={{ width: "100%", minHeight: containerHeight }}
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress color="neutral" />
        </Stack>
      </ContentTemplateV2>
    );
  }

  return (
    <ContentTemplateV2
      noPadding
      isWide
      setContainerHeight={setContainerHeight}
      containerId={SCROLL_CONTAINER_ID}
    >
      {containerHeight > 0 && (
        <Stack
          sx={{
            pb: "150px",
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          {/*영역 1: ~님의 프로그램 */}
          <Stack
            spacing={5}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "100%",
              mx: "auto",
              px: paddingX,
              pt: 6,
              pb: 8,
            }}
          >
            <Stack
              spacing={3}
              sx={{
                width: "100%",
                maxWidth: "660px",
                textAlign: "center",
              }}
            >
              <CustomTypography
                variant={"H1"}
                sx={{
                  paddingTop: "54px",
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 800,
                }}
              >
                {`${user?.nickname}님의 프로그램`}
              </CustomTypography>
              {/* 서브타이틀 문구 변경 */}
              <CustomTypography
                variant={"Subtitle"}
                sx={{
                  color: theme.vars.palette.Content.Medium,
                  fontWeight: 500,
                }}
              >
                {"마음을 다루는 근거있고\n" + "효과적인 방법을 제안합니다."}
              </CustomTypography>
            </Stack>

            {isFirstOrder && (
              <Stack
                spacing={"12px"}
                sx={{
                  width: "100%",
                  maxWidth: "660px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: theme.vars.palette.Surface.Forward,
                    borderRadius: "16px",
                    py: 4,
                    px: 3,
                  }}
                >
                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    주요 훈련 계획
                  </CustomTypography>
                  <Stack spacing={1} sx={{ mt: 2 }}>
                    {majorTrainingPlan.map((text, idx) => (
                      <Stack
                        key={idx}
                        direction={"row"}
                        spacing={0.5}
                        alignItems="center"
                      >
                        <img
                          src={numberWithCircle[idx]}
                          alt={"number"}
                          style={{}}
                        />
                        <CustomTypography
                          variant={"Body"}
                          sx={{
                            p: 0,
                            color: theme.vars.palette.Content.Strong,
                            fontWeight: 500,
                          }}
                        >
                          {text}
                        </CustomTypography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    backgroundColor: theme.vars.palette.Surface.Forward,
                    borderRadius: "16px",
                    py: 4,
                    px: 3,
                  }}
                >
                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    프로그램 구성
                  </CustomTypography>
                  <Stack spacing={1} sx={{ mt: 2 }}>
                    {programFeatures.map(({ main }, idx) => (
                      <Stack
                        key={idx}
                        direction="row"
                        alignItems="center"
                        spacing={0.5}
                      >
                        <img src={checkIconImg} alt={"checkImg"} />
                        <CustomTypography sx={{ p: 0 }}>
                          <CustomTypography
                            variant={"Body"}
                            sx={{
                              p: 0,
                              color: theme.vars.palette.Content.Strong,
                              fontWeight: 500,
                            }}
                          >
                            {main}
                          </CustomTypography>
                        </CustomTypography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            )}
          </Stack>

          {/* 플랜 선택 */}
          <Stack
            ref={planSectionRef}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Surface.Highlight,
              width: "100%",
              maxWidth: "100%",
              mx: "auto",
              px: paddingX,
              pt: 5,
              pb: 10,
            }}
          >
            <Stack
              sx={{
                width: "100%",
                maxWidth: isInappWebview ? "660px" : "1000px",
              }}
              spacing={5}
              alignItems="center"
            >
              <Box ref={planTitleRef} />

              <Stack spacing={"16px"}>
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    color: theme.vars.palette.Content.Negative,
                    fontWeight: 700,
                    textAlign: "center",
                  }}
                >
                  {isFirstOrder
                    ? "100일 완성\n플랜을 선택하세요"
                    : "플랜을 선택하세요"}
                </CustomTypography>
              </Stack>

              <Box
                sx={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: isInappWebview
                    ? "1fr"
                    : "repeat(3, minmax(0, 1fr))",
                  gap: "12px",
                }}
              >
                {plans.map((plan) => {
                  const selected = selectedPlan === plan.key;
                  return (
                    <Box
                      key={plan.key}
                      sx={{
                        borderRadius: "16px",
                        backgroundColor: theme.vars.palette.Surface.Forward,
                        px: "24px",
                        py: "28px",
                      }}
                    >
                      <Stack spacing={"20px"}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="flex-start"
                        >
                          <Stack spacing={0.5} sx={{ width: "100%" }}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              sx={{ width: "100%", pl: 0.5 }}
                            >
                              <CustomTypography
                                variant="Body"
                                sx={{
                                  color: theme.vars.palette.Content.Highlight,
                                  fontWeight: 700,
                                }}
                              >
                                {plan.name}
                              </CustomTypography>
                              {plan.tag && (
                                <Box
                                  sx={{
                                    height: "20px",
                                    borderRadius: "4px",
                                    px: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor:
                                      plan.tag === "가장 밀도 있는"
                                        ? theme.vars.palette.Surface
                                            .SoftHighlightWithAlert
                                        : theme.vars.palette.Surface
                                            .SoftHighlight,
                                  }}
                                >
                                  <Typography
                                    variant="Footnote"
                                    sx={{
                                      color:
                                        plan.tag === "가장 밀도 있는"
                                          ? theme.vars.palette.Content
                                              .HighlightWithAlert
                                          : theme.vars.palette.Content
                                              .Highlight,
                                      fontWeight: 700,
                                    }}
                                  >
                                    {plan.tag}
                                  </Typography>
                                </Box>
                              )}
                            </Stack>
                            <CustomTypography
                              variant="H3"
                              sx={{
                                color: theme.vars.palette.Content.Strong,
                                fontWeight: 700,
                              }}
                            >
                              {`${formatCurrency(plan.price)}원`}
                              <CustomTypography
                                component="span"
                                variant="Body"
                                sx={{
                                  ml: 0.5,
                                  color: theme.vars.palette.Content.Medium,
                                  fontWeight: 500,
                                }}
                              >
                                {"/ 100일"}
                              </CustomTypography>
                            </CustomTypography>
                          </Stack>
                        </Stack>

                        {/* 선택 버튼 */}
                        <Button
                          fullWidth
                          size="md"
                          variant={selected ? "Outlined" : "Soft"}
                          onClick={() => setSelectedPlan(plan.key)}
                          sx={{ borderRadius: "10px", fontWeight: 700 }}
                        >
                          {selected ? (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <CheckIcon ariaLabel="selected" />
                              <span>선택됨</span>
                            </span>
                          ) : (
                            "선택하기"
                          )}
                        </Button>

                        {countCoachSeatRemain && countCoachSeatRemain > 0 && plan.key !== "starter" &&
                         (
                            <Stack
                              direction="row"
                              spacing={"4px"}
                              sx={{
                                mt: "8px !important",
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                variant={"Caption"}
                                sx={{
                                  px: 0,
                                  color: theme.vars.palette.Content.Medium,
                                  fontWeight: 500,
                                }}
                              >
                                {"현재 신청 가능 인원:"}
                                <Typography
                                  variant={"Caption"}
                                  sx={{
                                    pr: 0,
                                    color:
                                    theme.vars.palette.Content
                                      .HighlightWithAlert,
                                    fontWeight: 500,
                                  }}
                                >
                                  {plan.key === "challenger"
                                    ? countCoachSeatRemain + 1
                                    : countCoachSeatRemain}
                                  명
                                </Typography>
                              </Typography>
                              <Box
                                role="button"
                                tabIndex={0}
                                aria-label={`정원 제한 자세히 보기`}
                                onClick={() =>
                                  handleOpenInfoCoachSeat(plan.name)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleOpenInfoCoachSeat(plan.name);
                                  }
                                }}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <InfoIcon ariaLabel="info" />
                              </Box>
                            </Stack>
                          )}

                        {/* 혜택 목록 */}
                        <Stack spacing={1}>
                          {(isFirstOrder
                            ? plan.features
                            : plan.features.filter(
                                (feat) => !feat.text.includes("환불")
                              )
                          ).map((f, idx) => (
                            <Stack
                              key={`${plan.key}-${idx}`}
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              sx={{ width: "100%" }}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={0.5}
                              >
                                <CheckIcon ariaLabel="included" />
                                <Typography
                                  variant="Body"
                                  sx={{
                                    px: 0,
                                    color: theme.vars.palette.Content.Strong,
                                    fontWeight: 500,
                                  }}
                                >
                                  {f.text === "14일 내 전액 환불 보장"
                                    ? refundLabel
                                    : f.text}
                                </Typography>
                              </Stack>
                              {f.info && (
                                <Box
                                  role="button"
                                  tabIndex={0}
                                  aria-label={`${f.text} 자세히 보기`}
                                  onClick={() => handleOpenInfo(f.text)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                      e.preventDefault();
                                      handleOpenInfo(f.text);
                                    }
                                  }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <InfoIcon ariaLabel="info" />
                                </Box>
                              )}
                            </Stack>
                          ))}
                        </Stack>
                      </Stack>
                    </Box>
                  );
                })}
              </Box>
            </Stack>
          </Stack>

          {showCountdown ? (
            <Stack
              py={10}
              spacing={5}
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level1,
                width: "100%",
                mx: "auto",
                px: paddingX,
              }}
            >
              <Stack alignItems="center" spacing={5} sx={{ width: "100%" }}>
                <Stack spacing={"4px"}>
                  <CustomTypography
                    variant={"Subtitle"}
                    sx={{
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                      textAlign: "center",
                    }}
                  >
                    {"잔여 자리 확보 시간"}
                  </CustomTypography>
                  <CustomTypography
                    variant={"H1"}
                    sx={{
                      py: 0,
                      color: theme.vars.palette.Content.Strong,
                      fontWeight: 700,
                      textAlign: "center",
                    }}
                  >
                    {formatHHMMSS(remainingSeconds)}
                  </CustomTypography>
                </Stack>

                <Stack
                  direction="column"
                  alignItems="start"
                  sx={{ width: "100%", maxWidth: "660px" }}
                >
                  <CustomTypographyHighlight
                    variant={"Subtitle"}
                    sx={{
                      color: theme.vars.palette.Content.Medium,
                      fontWeight: 500,
                    }}
                    highlightedTexts={["임시로 확보", "임시 예약이 해제", "자동으로 파기"]}
                    highlightSx={{
                      color: theme.vars.palette.Content.Strong,
                      fontWeight: 700,
                    }}
                  >
                    {`제출하신 설문을 바탕으로 각 플랜별 자리를 임시로 확보해두었습니다.

15분이 지나면 임시 예약이 해제되어 다음 이용자에게 기회가 넘어갈 수 있습니다.

또한 생성된 맞춤 프로그램이 자동으로 파기되어, 설문을 다시 제출해야 할 수 있습니다.`}
                  </CustomTypographyHighlight>
                </Stack>
              </Stack>
            </Stack>
          ) : null}

          {isFirstOrder && (
            <Stack
              py={10}
              spacing={5}
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Content.Strong,
                width: "100%",
                mx: "auto",
                px: paddingX,
              }}
            >
              <Stack alignItems="center" spacing={6} sx={{ width: "100%" }}>
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    color: theme.vars.palette.Content.SoftHighlight,
                    fontWeight: 700,
                    textAlign: "center",
                  }}
                >
                  {"100일이면\n완성되는 새로운 삶"}
                </CustomTypography>

                <Stack
                  direction="column"
                  alignItems="start"
                  sx={{ width: "100%", maxWidth: "660px" }}
                >
                  <CustomTypographyHighlight
                    variant={"Subtitle"}
                    sx={{
                      color: theme.vars.palette.Content.SuperWeak,
                      fontWeight: 500,
                    }}
                    highlightedText={"1%도 되지 않는"}
                    highlightVariant={"Subtitle"}
                    highlightSx={{
                      color: theme.vars.palette.Content.Negative,
                      fontWeight: 700,
                    }}
                  >
                    {"단 100일. 디스턴싱으로 변화를 만드는 데 걸리는 시간입니다.\n\n" +
                      "앞으로 남은 인생이 50년이라면, 이 100일은 1%도 되지 않는 아주 짧은 시간입니다.\n\n" +
                      "1로 99를 얻는 기회, 지금 시작하세요."}
                  </CustomTypographyHighlight>
                </Stack>
              </Stack>
            </Stack>
          )}

          {isFirstOrder && user?.refundPolicyType === "a" && (
            <Stack
              py={10}
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level1,
                width: "100%",
                px: paddingX,
                mx: "auto",
              }}
            >
              <Stack
                spacing={4}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <img
                  src={paybackMarkImg}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: "121px",
                  }}
                />
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"효과 보장 페이백"}
                </CustomTypography>
              </Stack>

              <Stack
                direction="column"
                alignItems="start"
                spacing={2}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                  }}
                  highlightedText={"비용 전액"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"디스턴싱 프로그램의 첫째 주 만족도는 92%. 그러나 100일 뒤 이 만족도는 98%로 더욱 높아집니다.\n\n" +
                    "100일 동안 주 1회 이상 참여한 후에도 변화가 느껴지지 않으신다면 비용 전액을 돌려드립니다.\n\n" +
                    "주 1회 이상 참여하는 게 어려울 것 같나요? 그렇지 않아요. 30분 정도면 충분하고, 전담 코치 선생님이 꾸준히 프로그램에 참여할 수 있도록 도와줄 거랍니다.\n\n" +
                    "시도해서 잃을 것은 없습니다. 시도하지 않으면 변화할 기회조차 얻지 못합니다."}
                </CustomTypographyHighlight>
              </Stack>
            </Stack>
          )}

          {isFirstOrder && user?.refundPolicyType !== "a" && (
            <Stack
              py={10}
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level1,
                width: "100%",
                px: paddingX,
                mx: "auto",
              }}
            >
              <Stack
                spacing={4}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <img
                  src={paybackMarkImg}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: "121px",
                  }}
                />
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"14일 전액 환불 보장"}
                </CustomTypography>
              </Stack>

              <Stack
                direction="column"
                alignItems="start"
                spacing={2}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                  }}
                  highlightedText={"비용 전액"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"디스턴싱 프로그램의 첫째 주 만족도는 92%. 그러나 100일 뒤 이 만족도는 98%로 더욱 높아집니다.\n\n" +
                    "결제일로부터 14일 이내 2세트 이상 제공된 활동지를 진행했음에도 만족스럽지 못하다면, 이유와 관계없이 비용 전액을 환불해드립니다.\n\n" +
                    "시도해서 잃을 것은 없습니다. 시도하지 않으면 변화할 기회조차 얻지 못합니다."}
                </CustomTypographyHighlight>
              </Stack>
            </Stack>
          )}

          {/*변화를 위한 투자*/}
          <Stack
            py={10}
            spacing={5}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level3,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Stack
              direction="column"
              alignItems="start"
              spacing={"20px"}
              sx={{ width: "100%", maxWidth: "660px" }}
            >
              <img
                src={rocketImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "35px",
                }}
              />
              <CustomTypography
                variant={"H2"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {"변화를 위한 투자,\n하루 4천 원"}
              </CustomTypography>
            </Stack>

            <Stack
              spacing={3}
              direction="column"
              alignItems="start"
              sx={{ width: "100%", maxWidth: "660px" }}
            >
              <CustomTypographyHighlight
                variant={"Subtitle"}
                sx={{
                  color: theme.vars.palette.Content.Medium,
                  fontWeight: 500,
                  p: 0,
                }}
                highlightedText={"커피 한 잔 가격"}
                highlightVariant={"Subtitle"}
                highlightSx={{
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {"최상위 마스터 플랜을 선택하더라도 하루 이용 비용은 4천 원 대에 불과합니다. 커피 한 잔 가격으로 당신의 삶을 완전히 바꿀 기회입니다.\n\n" +
                  "혁신적인 방법으로 완성한 전 세계 유일의 통합 인지치료, 디스턴싱. 지금 바로 시작하세요."}
              </CustomTypographyHighlight>
            </Stack>
          </Stack>

          {/*영역4: 리뷰*/}
          <Stack
            py={10}
            spacing={"30px"}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Content.Strong,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Box
              sx={{
                maxWidth: "660px",
              }}
            >
              <Stack alignItems="center" spacing={6}>
                <Stack alignItems="center" spacing={2}>
                  <img
                    src={fivestarsImg}
                    alt={"empty"}
                    style={{
                      width: "100%",
                      maxWidth: "124px",
                    }}
                  />

                  <CustomTypography
                    variant={"H2"}
                    sx={{
                      color: theme.vars.palette.Content.SoftHighlight,
                      fontWeight: 700,
                    }}
                  >
                    500+개의 5점 리뷰
                  </CustomTypography>
                </Stack>

                {/* 후기 항목들 */}
                <Stack spacing={6} alignItems="center">
                  <ReviewItem
                    avatarIcon={reviewAvatar1Img}
                    text={"생각을 바라보는\n완전히 새로운 접근"}
                  />
                  <ReviewItem
                    avatarIcon={reviewAvatar2Img}
                    text={"신선하고 사려깊은\n과학적인 프로그램"}
                  />
                  <ReviewItem
                    avatarIcon={reviewAvatar3Img}
                    text={"지금껏 받아봤던\n인지행동치료 중 최고"}
                  />
                </Stack>
              </Stack>
            </Box>
          </Stack>

          {/*100일간의 집중 코칭*/}
          {isFirstOrder && (
            <Stack
              py={10}
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Surface.Highlight,
                width: "100%",
                px: paddingX,
                mx: "auto",
              }}
            >
              <Stack
                spacing={4}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <img
                  src={focusCoachingImg}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: "80px",
                  }}
                />
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    color: theme.vars.palette.Content.Negative,
                    fontWeight: 700,
                  }}
                >
                  {"100일 간의 1:1 코칭"}
                </CustomTypography>
              </Stack>

              <Stack
                direction="column"
                alignItems="start"
                spacing={2}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.SoftHighlight,
                    fontWeight: 500,
                  }}
                  highlightedText={"맞춤형 프로그램"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Negative,
                    fontWeight: 700,
                  }}
                >
                  {"프로그램이 시작되면 전담 코치가 배정됩니다.\n\n" +
                    "코치는 심리학 분야에서 석사 이상의 학위를 갖추고, 공인자격증을 갖춘 심리전문가들이죠.\n\n" +
                    "매일 코치와 함께 맞춤형 프로그램으로 디스턴싱 기술을 익히세요."}
                </CustomTypographyHighlight>
              </Stack>
              <img
                src={taskUpdateMechanism}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "321px",
                }}
              />
            </Stack>
          )}

          {/*단 한번의 결심*/}
          {isFirstOrder && (
            <Stack
              py={10}
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level3,
                width: "100%",
                mx: "auto",
                px: paddingX,
              }}
            >
              <Stack
                direction="column"
                alignItems="start"
                spacing={"20px"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <img
                  src={muscleImg}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: "35px",
                  }}
                />
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    p: 0,
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"아는 것과 행하는 것은\n" + "천지 차이"}
                </CustomTypography>
              </Stack>

              <Stack
                spacing={5}
                justifyContent="center"
                alignItems={"center"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <Stack
                  spacing={3}
                  direction="column"
                  alignItems="start"
                  sx={{ width: "100%" }}
                >
                  <CustomTypographyHighlight
                    variant={"Subtitle"}
                    sx={{
                      color: theme.vars.palette.Content.Medium,
                      fontWeight: 500,
                      p: 0,
                    }}
                    highlightedText={"배운 지식을 일상에 적용"}
                    highlightVariant={"Subtitle"}
                    highlightSx={{
                      color: theme.vars.palette.Content.Strong,
                      fontWeight: 700,
                    }}
                  >
                    {"프로그램은 단순한 이해에 그치지 않고, 디스턴싱 기술을 훈련할 수 있는 다양한 도구를 제공합니다.\n\n" +
                      "배운 지식을 일상에 적용하며, 눈에 보이는 변화를 경험하세요."}
                  </CustomTypographyHighlight>
                </Stack>
                <Stack
                  spacing={"20px"}
                  sx={{
                    ...(isInappWebview && {
                      width: "100%",
                      margin: "0 auto",
                    }),
                  }}
                >
                  {toolFeatures.map((feature, index) => (
                    <Stack
                      gap={10}
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <img
                          src={feature.icon}
                          alt=""
                          style={{ width: "20px", height: "20px" }}
                        />
                        <CustomTypography
                          variant="Body"
                          sx={{
                            color: theme.vars.palette.Content.Strong,
                            fontWeight: 700,
                          }}
                        >
                          {feature.text}
                        </CustomTypography>
                      </Stack>
                    </Stack>
                  ))}
                </Stack>
              </Stack>
            </Stack>
          )}

          {/*영역5: 100일로 완성되는*/}
          {isFirstOrder && (
            <Stack
              py={10}
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level1,
                width: "100%",
                mx: "auto",
                px: paddingX,
              }}
            >
              <Stack
                direction="column"
                alignItems="start"
                spacing={"20px"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <img
                  src={calendarImg}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: "35px",
                  }}
                />
                <Typography
                  variant={"H2"}
                  sx={{
                    p: 0,
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"100일로 완성되는\n지속가능한 변화"}
                </Typography>
              </Stack>

              <Stack
                spacing={5}
                justifyContent="center"
                alignItems={"center"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <Stack spacing={3}>
                  <CustomTypographyHighlight
                    variant={"Subtitle"}
                    sx={{
                      color: theme.vars.palette.Content.Medium,
                      fontWeight: 500,
                      p: 0,
                    }}
                    highlightedText={"디스턴싱 기술이 체화"}
                    highlightVariant={"Subtitle"}
                    highlightSx={{
                      color: theme.vars.palette.Content.Strong,
                      fontWeight: 700,
                    }}
                  >
                    {
                      "디스턴싱은 지속가능한 변화를 위해 설계되었습니다. 이 지속가능성은 디스턴싱 기술이 체화되어 일상에서 자연스럽게 실천될 때에 완성됩니다."
                    }
                  </CustomTypographyHighlight>
                  <CustomTypographyHighlight
                    variant={"Subtitle"}
                    sx={{
                      color: theme.vars.palette.Content.Medium,
                      fontWeight: 500,
                      p: 0,
                    }}
                    highlightedText={"필요한 기간은 100일"}
                    highlightVariant={"Subtitle"}
                    highlightSx={{
                      color: theme.vars.palette.Content.Strong,
                      fontWeight: 700,
                    }}
                  >
                    {
                      "디스턴싱에서 성공적인 효과를 보인 80,000명의 데이터를 분석한 결과 안정적인 정착을 위해 필요한 기간은 100일이었습니다."
                    }
                  </CustomTypographyHighlight>
                  <CustomTypographyHighlight
                    variant={"Subtitle"}
                    sx={{
                      color: theme.vars.palette.Content.Medium,
                      fontWeight: 500,
                      p: 0,
                    }}
                    highlightedText={
                      "디스턴싱은 번쩍이는 요행을 바라지 않습니다."
                    }
                    highlightVariant={"Subtitle"}
                    highlightSx={{
                      color: theme.vars.palette.Content.Strong,
                      fontWeight: 700,
                    }}
                  >
                    {
                      "디스턴싱은 번쩍이는 요행을 바라지 않습니다. 디스턴싱은 평생에 걸친 장기적인 변화를 만듭니다."
                    }
                  </CustomTypographyHighlight>
                </Stack>
                <img
                  src={chart100Img}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: "321px",
                  }}
                />
              </Stack>
            </Stack>
          )}

          <Stack
            py={10}
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{
              backgroundColor: theme.vars.palette.Background.Level3,
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
              position: "relative",
              overflow: "visible",
              pb: "50px",
            }}
          >
            <Stack spacing={"44px"} alignItems={"center"}>
              <CustomTypography
                variant={"Body"}
                sx={{
                  color: theme.vars.palette.Content.Medium,
                  fontWeight: 510,
                }}
              >
                {"Supported by"}
              </CustomTypography>
              <img
                src={sponsorImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  paddingBottom: "60px",
                }}
              />
            </Stack>
            <CustomTypography
              pt={5}
              variant="Body"
              sx={{
                color: theme.vars.palette.Content.Medium,
                fontWeight: 500,
              }}
            >
              PC, 모바일 완벽 지원
            </CustomTypography>

            <Box
              sx={{
                mr: "-60px",
                mt: 2,
                width: "90%",
                alignSelf: "flex-end",
              }}
            >
              <img
                src={pcAndMobileImg}
                alt="pc_and_mobile"
                style={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </Box>
          </Stack>

          <Stack
            py={10}
            spacing={"30px"}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level1,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Stack spacing={10} sx={{ width: "100%", maxWidth: "660px" }}>
              {comparisonItems.map(({ type, title, text, icon }) => (
                <Stack
                  key={type}
                  spacing="40px"
                  sx={{
                    borderRadius: "12px",
                  }}
                >
                  <Stack
                    spacing={"20px"}
                    direction="column"
                    alignItems="start"
                    sx={{ width: "100%" }}
                  >
                    <img
                      src={icon}
                      alt={"empty"}
                      style={{
                        width: "100%",
                        maxWidth: "35px",
                      }}
                    />
                    <Typography
                      variant={"H2"}
                      sx={{
                        p: 0,
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 700,
                      }}
                    >
                      {title}
                    </Typography>
                  </Stack>
                  <Stack spacing="40px">
                    <CustomTypography
                      variant={"Subtitle"}
                      sx={{
                        p: 0,
                        color: theme.vars.palette.Content.Medium,
                        fontWeight: 500,
                      }}
                    >
                      {text}
                    </CustomTypography>
                    <CompareWithCounseling395 type={type} />
                    <CustomTypography
                      variant={"Caption"}
                      sx={{
                        p: 0,
                        color: theme.vars.palette.Content.Medium,
                        fontWeight: 500,
                      }}
                    >
                      {"* 마스터 플랜 기준"}
                    </CustomTypography>
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </Stack>

          {isFirstOrder && (
            <Stack
              py={10}
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Content.Strong,
                width: "100%",
                px: paddingX,
                mx: "auto",
              }}
            >
              <Stack
                spacing={4}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <CustomTypography
                  variant={"H2"}
                  textAlign={"center"}
                  sx={{
                    color: theme.vars.palette.Content.SoftHighlight,
                    fontWeight: 700,
                  }}
                >
                  {"매일의 루틴이\n" + "만드는 변화"}
                </CustomTypography>
              </Stack>

              <Stack
                spacing={3}
                alignItems={"start"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 700,
                    color: theme.vars.palette.Content.Negative,
                  }}
                >
                  {"코칭 시간"}
                </CustomTypography>
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.SuperWeak,
                  }}
                >
                  {
                    "코치는 평일 오전 8시부터 오후 7시 사이에 코칭을 진행합니다."
                  }
                </CustomTypography>

                <img
                  src={coachingTimeImg}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: isInappWebview ? "660px" : "360px",
                    display: "block",
                    margin: "0 auto",
                    marginTop: "24px",
                  }}
                />
              </Stack>

              <img
                src={dividerImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "660px",
                }}
              />

              <Stack
                spacing={3}
                alignItems={"start"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 700,
                    color: theme.vars.palette.Content.Negative,
                  }}
                >
                  {"코칭 루틴"}
                </CustomTypography>
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.SuperWeak,
                  }}
                >
                  {
                    "오후 3시 이전에 주어진 모든 활동을 완료하면, 당일에 피드백과 함께 다음 활동지가 제공됩니다."
                  }
                </CustomTypography>

                <img
                  src={coachingRoutine1Img}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: isInappWebview ? "660px" : "360px",
                    display: "block",
                    margin: "0 auto",
                    marginTop: "24px",
                  }}
                />
              </Stack>

              <Stack
                spacing={3}
                alignItems={"start"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.SuperWeak,
                  }}
                >
                  {"오후 3시 이후에 완료하면, 다음 날 업데이트가 이루어집니다."}
                </CustomTypography>
                <img
                  src={coachingRoutine2Img}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: isInappWebview ? "660px" : "360px",
                    display: "block",
                    margin: "0 auto",
                    marginTop: "24px",
                  }}
                />
                <img
                  src={coachingRoutine3Img}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: isInappWebview ? "660px" : "360px",
                    display: "block",
                    margin: "0 auto",
                    marginTop: "24px",
                  }}
                />
              </Stack>
              <Stack
                spacing={3}
                alignItems={"start"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.SuperWeak,
                  }}
                >
                  {
                    "즉, 완료 시각과 관계없이 활동을 매일 완료하면 업데이트도 매일 받을 수 있습니다. (단, 스타터 플랜은 주 2회 제공)"
                  }
                </CustomTypography>
              </Stack>
              <img
                src={dividerImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "660px",
                }}
              />

              <Stack
                spacing={3}
                alignItems={"start"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 700,
                    color: theme.vars.palette.Content.Negative,
                  }}
                >
                  {"플랜별 코칭 횟수"}
                </CustomTypography>
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.SuperWeak,
                  }}
                  highlightedText={"마스터"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Negative,
                    fontWeight: 700,
                  }}
                >
                  {
                    "마스터: 오후 3시 이전에 두 차례 활동을 완료한 경우, 당일 최대 2회까지 업데이트가 가능합니다."
                  }
                </CustomTypographyHighlight>

                <img
                  src={coachingCount1Img}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: isInappWebview ? "660px" : "360px",
                    display: "block",
                    margin: "0 auto",
                    marginTop: "24px",
                  }}
                />
              </Stack>

              <Stack
                spacing={3}
                alignItems={"start"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.SuperWeak,
                  }}
                  highlightedText={"챌린저"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Negative,
                    fontWeight: 700,
                  }}
                >
                  {
                    "챌린저: 일 최대 1회 업데이트로 제한되며, 오후 3시 이전에 완료된 두 번째 활동에 대해서는 다음 날 업데이트가 제공됩니다."
                  }
                </CustomTypographyHighlight>
                <img
                  src={coachingCount2Img}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: isInappWebview ? "660px" : "360px",
                    display: "block",
                    margin: "0 auto",
                    marginTop: "24px",
                  }}
                />
                <img
                  src={coachingCount3Img}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: isInappWebview ? "660px" : "360px",
                    display: "block",
                    margin: "0 auto",
                    marginTop: "24px",
                  }}
                />
              </Stack>
              <Stack
                spacing={3}
                alignItems={"start"}
                sx={{ width: "100%", maxWidth: "660px" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.SuperWeak,
                  }}
                  highlightedText={"스타터"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Negative,
                    fontWeight: 700,
                  }}
                >
                  {
                    "스타터: 일 최대 업데이트 횟수는 1회로 챌린저 플랜과 동일하지만, 주 최대 2회까지 업데이트가 제공됩니다."
                  }
                </CustomTypographyHighlight>
              </Stack>
            </Stack>
          )}

          {isFirstOrder && (
            <Stack
              py={10}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level3,
                width: "100%",
                mx: "auto",
                px: paddingX,
              }}
            >
              <Stack spacing={5} sx={{ width: "100%", maxWidth: "660px" }}>
                <Typography
                  variant={"H2"}
                  sx={{
                    p: 0,
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"자주 묻는 질문"}
                </Typography>
                <FAQTypeC />
              </Stack>
            </Stack>
          )}

          <Stack
            spacing={2}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level3,
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
              px: paddingX,
              pt: isFirstOrder ? 0 : 9,
            }}
          >
            <Stack direction={"row"} spacing={3}>
              {user && <UserInfo user={user} />}
              {<CxButton type="link" />}
            </Stack>
            <Stack direction={"row"} spacing={3}>
              <LinkV2 text={"사업자 정보"} url={companyInfoUrl} />
              <LinkV2 text={"개인정보 처리방침"} url={privacyPolicyUrl} />
              <LinkV2 text={"서비스 이용약관"} url={servicePolicyUrl} />
            </Stack>
          </Stack>

          <Box>
            <FloatingArea
              fullWidth={fullWidth}
              ref={floatingAreaRef}
              paddingBottom={isInappWebview ? "4px" : "12px"}
            >
              <Stack
                spacing={1.5}
                sx={{ width: "100%" }}
                alignItems="center"
                justifyContent={"space-between"}
              >
                {/* 선택된 플랜에 따른 문구 동기화 */}
                <CustomTypography
                  variant={"Caption"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.Medium,
                    textAlign: "center",
                  }}
                >
                  {isFirstOrder
                    ? `100일 완성 ${formatCurrency(selectedPlanObj.price)}원\u00A0\u00A0|\u00A0\u00A0${guaranteeLabel}`
                    : `100일 ${formatCurrency(selectedPlanObj.price)}원\u00A0\u00A0|\u00A0\u00A0언제든 환불 가능`}
                </CustomTypography>

                <Stack
                  spacing={"16px"}
                  sx={{ width: "100%" }}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  {paymentOrderState && (
                    <PaymentButtonWithPlanSelection
                      selectedPlan={selectedPlan}
                      beforeRequestPayment={undefined}
                    />
                  )}

                  <CustomTypography
                    onClick={handleScrollToPlans}
                    variant="Caption"
                    sx={{
                      cursor: "pointer",
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                      textDecoration: "underline",
                      textUnderlineOffset: "2px",
                    }}
                  >
                    다른 플랜 보기
                  </CustomTypography>
                </Stack>
              </Stack>
            </FloatingArea>
          </Box>
        </Stack>
      )}
      <CustomModal
        open={infoModalOpen}
        onClose={() => setInfoModalOpen(false)}
        title={infoModal.title}
        subtitle={infoModal.subtitle}
        actions={[
          {
            label: infoModal.action,
            onClick: () => setInfoModalOpen(false),
            variant: "Solid",
          },
        ]}
      />
    </ContentTemplateV2>
  );
}
